<script setup lang="ts">
  const props = defineProps<{
    wFull?: boolean;
  }>();

  const modelValue = defineModel<number[] | null | undefined>();
  const BASE_UI = {
    root: `relative flex items-center ${props.wFull ? 'justify-between' : ''}`,
    base: 'rounded-md border-0 placeholder:text-dimmed text-center h-[54px] w-[50px] focus:outline-solid focus:outline-1 focus-visible:outline-1 focus-visible:outline-primary focus-visible:ring-0  disabled:cursor-not-allowed disabled:opacity-75 transition-colors bg-black/20 text-white',
  };
</script>

<template>
  <UPinInput
    v-model="modelValue"
    type="number"
    inputmode="numeric"
    color="neutral"
    otp
    variant="subtle"
    size="xl"
    :length="6"
    :ui="BASE_UI"
  />
</template>
